import React from 'react';

const RuleTestingFilters = ({
  customers,
  rulesetTypes,
  selectedCustomerId,
  selectedRulesetTypeId,
  onCustomerChange,
  onRulesetTypeChange,
  loading,
  hideCustomerFilter = false,
}) => {
  return (
    <div style={{ 
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '4px'
    }}>
      <div className="row mb-3">
        {!hideCustomerFilter && (
          <div className="col-md-6">
            <label htmlFor="customerFilter" className="form-label">
              <strong>Customer</strong> <span className="text-danger">*</span>
            </label>
            <select
              id="customerFilter"
              className="form-select"
              value={selectedCustomerId}
              onChange={(e) => onCustomerChange(e.target.value)}
              disabled={loading}
            >
              <option value="">Select Customer</option>
              {customers.map(customer => (
                <option key={customer.id} value={customer.id}>
                  {customer.customerName}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className={hideCustomerFilter ? "col-md-12" : "col-md-6"}>
          <label htmlFor="rulesetTypeFilter" className="form-label">
            <strong>Ruleset Type</strong>
          </label>
          <select
            id="rulesetTypeFilter"
            className="form-select"
            value={selectedRulesetTypeId}
            onChange={(e) => onRulesetTypeChange(e.target.value)}
            disabled={!selectedCustomerId || loading}
          >
            <option value="">All Ruleset Types</option>
            {rulesetTypes.map(type => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default RuleTestingFilters;
